import Component from '@galactic-advisors/component-loader';
import axios from 'axios';
import { Toast, ToastStatusTypes } from '../../../../../../../ts/toast.ts';

const DEFAULTS = {
  submitButtonElement: '[data-submit-button]',
  submitButtonTextElement: '[data-button-text]',
  formElement: '[data-form]',
  loaderElement: '[data-loader]',
};

export default class ApprovalCreateForm extends Component {
  static selector = '[data-comp-company-protocol-approval-create-form]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.submitButton = this.$container.querySelector(
      this.$options.submitButtonElement
    );

    this.form = this.$container.querySelector(this.$options.formElement);

    this.loader = this.$container.querySelector(this.$options.loaderElement);

    this.submitButtonText = this.$container.querySelector(
      this.$options.submitButtonTextElement
    );

    this.toast = Toast.instance;

    this.init();
  }

  submitForm(requestData) {
    const request = axios.post(this.form.action, requestData).catch((error) => {
      this.toast.show(ToastStatusTypes.DANGER, error.response.data.message);
      console.error({ error });
    });
    return request;
  }

  init() {
    this.submitButton.addEventListener('click', (event) => {
      event.preventDefault();

      const formData = new FormData(this.form);
      const requestData = Object.fromEntries(formData);

      this.toast.show(ToastStatusTypes.SUCCESS, 'Submitting Approval');
      this.submitButtonText.innerText = 'Submitting...';
      this.loader.classList.remove('d-none');

      this.submitForm(requestData).then((response) => {
        this.toast.show(ToastStatusTypes.SUCCESS, 'Approved Successfully!');

        if (response && !response.data.data) {
          alert(response.data.message);
          window.location.replace(response.data.redirect_url);
        }

        if (response && response.data.data) {
          window.location.replace(response.data.data.redirect_url);
        }
      });
    });
  }
}
